<template>
  <div class="main-wrap noticeDetails">
    <div class="container">
      <div class="pagination-footer">
        <div class="box pagination-1">
          <div class="_left">
            <h3>皇太后公告 <i class="iconfont icon-ico2"></i></h3>
            <div class="_time"><span>{{dataObj.created_at}}</span></div>
          </div>
          <div class="_right">
            <div class="_box">{{dataObj.title}}
              <!--              <i class="iconfont icon-ico3"></i>-->
            </div>
          </div>
        </div>
        <div class="pagination-2">
          <div class="box">
            <span>＜ 上一則</span>
          </div>
          <div class="box">
            <span>下一則 ＞</span>
          </div>
        </div>
      </div>

      <div class="details-box">
        <div class="box">
          <div class="_html" v-html="dataObj.content">

          </div>
        </div>
      </div>


<!--      <div class="details-footer">-->
<!--        <div class="box" v-for="(item,i) in dataObj.appendix" :key="i">-->
<!--          <i class="icon-ico3 iconfont"></i>-->
<!--          <span>{{item.name}}</span>-->
<!--        </div>-->
<!--      </div>-->

    </div>
  </div>
</template>

<script>

import { agencyMessageDetail } from "@/api";

export default {
  name: "Notice",
  data() {
    return {
      dataObj: {}
    };
  },
  created() {

  },
  mounted() {
    this.getDetail();
  },
  beforeDestroy() {
  },
  methods: {
    getDetail() {
      agencyMessageDetail({ id: this.$route.query.id }).then(res => {
        this.dataObj = res.data.item;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.home {

}
</style>
